<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="isReloadAlive"/>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'app',
  provide () { // 实现页面刷新
    return {
      reload: this.reload
    }
  },
  components: {
  },
  data () {
    return {
      isReloadAlive: true
    }
  },
  methods: {
    reload () {
      this.isReloadAlive = false
      this.$nextTick(() => {
        this.isReloadAlive = true
      })
    }
  }
}
</script>
<style>
/* Noto Sans SC */
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+SC&display=swap");

#app {
  font-family: -apple-system, "Avenir", "Noto Sans SC", Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #595757;
  font-size: 16px;
}
</style>
